import React, { useEffect } from 'react';

import { useTheme } from '@mui/material/styles';
import { Global, CSSObject, css } from '@emotion/react';

const useStyles = (): CSSObject => {
  const theme = useTheme();

  return {
    body: {
      WebkitTextSizeAdjust: '100%',
      minWidth: 360,
      overflowX: 'hidden',
    },
    iframe: {
      margin: 0,
      padding: 0,
      border: 'none',
      outline: 'none',
    },
    '.mac-scroll-styles': {
      '& *::-webkit-scrollbar, &::-webkit-scrollbar': {
        backgroundColor: theme.tokens.colors.bg.light.secondary, // TODO - fix нет в токенах
        width: '12px',
      },
      '& *::-webkit-scrollbar-thumb, &::-webkit-scrollbar-thumb': {
        backgroundColor: '#babac0', // TODO - fix нет в токенах
        borderRadius: '8px',
        backgroundClip: 'content-box',
        border: '2px solid transparent',
      },
      '& *::-webkit-scrollbar-thumb:hover, &::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#a0a0a5', // TODO - fix нет в токенах
      },
      '& *::-webkit-scrollbar-button, &::-webkit-scrollbar-button': {
        display: 'none',
      },
    },
    pre: {
      display: 'inline',
      fontFamily: 'inherit',
      margin: theme.tokens.spacing[0],
    },
    'ul, ol': {
      listStyle: 'none',
      margin: theme.tokens.spacing[0],
      padding: theme.tokens.spacing[0],
    },

    'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: theme.tokens.spacing[0],
    },

    'input[type=number]': {
      MozAppearance: 'textfield',
    },

    'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus':
      {
        backgroundColor: `${theme.tokens.colors.bg.light.primary} !important`,
        WebkitTextFillColor: 'rgb(80, 84, 99)', // TODO - fix нет в токенах
        WebkitBoxShadow: `0 0 0px 1000px ${theme.tokens.colors.bg.light.primary} inset`,
      },
    '.nowrap': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '.noshrink': {
      flexShrink: 0,
    },
    '.webim-root': {
      '@media (min-width: 1024px)': {
        top: 'auto !important',
        left: 'auto !important',
        bottom: '137px',
        right: '48px',
      },
    },
    '.webim-dialogue': {
      borderBottom: 'none !important',
    },
    '.webim-root .webim-mobile-mode, .webim-root .webim-separate-mode': {
      top: '0 !important',
      left: '0 !important',
      bottom: '0 !important',
      right: '0 !important',
    },
    '.webim-powered-by-webim': {
      display: 'none',
    },
    '.webim-visitor-message span, .webim-visitor-message a, .webim-visitor-message .webim-file-size':
      {
        color: `${theme.tokens.colors.bg.light.primary} !important`,
      },
    '.webim-visitor-message .webim-file-size': {
      opacity: '.5',
    },
    '.webim-header': {
      background: `${theme.tokens.colors.original.brand.primary} !important`,
      paddingLeft: '90px !important', // TODO - fix нет в токенах
      cursor: 'default !important',
    },
    '.webim-header::after': {
      content: "''",
      position: 'absolute',
      left: '24px',
      top: '50%',
      transform: 'translate(0, -50%)',
      width: '32px',
      height: '32px',
      padding: `${theme.tokens.spacing[8]}px`,
      borderRadius: `${theme.tokens.radius.m}px`,
      background: `${theme.tokens.colors.bg.light.primary} url(/icons/vk-logo-icon.svg) no-repeat center`,
    },
    '.webim-notification-alert .webim-header::after': {
      display: 'none',
    },
    '.webim-root .webim-operator-block > .webim-operator': {
      marginLeft: `${theme.tokens.spacing[0]} !important`,
    },
    '.webim-root .webim-no-operator-block': {
      paddingLeft: `${theme.tokens.spacing[0]} !important`,
    },
    '.webim_button': {
      background: `${theme.tokens.colors.bg.light.primary} url(/icons/${theme.tokens.name}-icon-chat.svg) 50% 50% no-repeat !important`,
      borderRadius: `${theme.tokens.radius.l}px !important`,
      border: 'none !important',
      color: theme.tokens.colors.bg.light.primary,
      display: 'none !important',
      '@media (min-width: 1024px)': {
        display: 'block !important',
        right: '48px !important',
        bottom: '58px !important',
        width: '72px !important',
        height: '72px !important',
      },
    },
    '.webim_button_no_loaded': css`
      position: fixed;
      cursor: pointer;
      z-index: 101 !important;
      background: ${theme.palette.background.paper};
      border: 1px solid #e2e2ea;
      box-sizing: border-box;
      box-shadow: 0 2px 8px rgba(0, 26, 77, 0.1),
        0 6px 28px rgba(0, 26, 77, 0.12);
      border-radius: 16px;
      padding: 12px !important;
    `,
    '.webim_button_loading': css`
      display: flex !important;
      align-items: center;
      justify-content: center;
      z-index: 101 !important;
      background: ${theme.palette.background.paper} !important;
      pointer-events: none;
      cursor: default;

      & span {
        max-height: 30px;
      }
    `,
    '.webim_button img, .webim-avatar, .webim_button.hidden, .webim-message-body:after, .webim-message div[data-webim-region="button-rows"]':
      {
        display: 'none !important',
      },
    '.webim-form-control textarea, .webim-root .webim-dialogue-message textarea, .webim-root .webim-dialogue-message .webim-textarea-ext':
      {
        fontSize: '16px !important', // TODO - fix нет в токенах
      },
    '.webim-popups-block': {
      paddingTop: '7px !important', // TODO - fix нет в токенах
    },
    '.webim_invitediv': css`
      z-index: 100 !important;
    `,
    '.webim-desktop-mode.webim-chat-button': css`
      z-index: 99 !important;
    `,
    '.webim-button-corner': css`
      background: ${theme.tokens.colors.bg.light.primary};
      border: ${theme.tokens.border.s}px solid #e2e2ea; // TODO - fix нет в токенах
      box-sizing: border-box;
      z-index: 99 !important;
      box-shadow: 0 2px 8px rgba(0, 26, 77, 0.1),
        0 6px 28px rgba(0, 26, 77, 0.12); // TODO - fix нет в токенах
      border-radius: ${theme.tokens.radius.l}px;
      padding: ${theme.tokens.spacing[12]}px !important;
    `,
    '.webim-button-corner-button': {
      bottom: '92px !important',
    },
    '.webim-button-corner-right': {
      right: '520px !important',
    },
    '.webim-chat-button': {
      bottom: '174px !important',
    },
    '.webim-chat-right': {
      right: '520px !important',
    },
    '.webim-button-row': {
      flexWrap: 'wrap',
      flexDirection: 'row-reverse',
    },
    '.webim-button-row .webim-btn': css`
      white-space: nowrap !important;
      flex-grow: 0 !important;
      flex-basis: auto !important;
      margin: ${theme.tokens.spacing[0]} ${theme.tokens.spacing[4]}px 10px; // TODO - fix нет в токенах
      background: ${theme.tokens.colors.bg.light.primary} !important;
      border: ${theme.tokens.border.m}px solid #115cef; // TODO - fix нет в токенах
      box-sizing: border-box;
      border-radius: ${theme.tokens.radius.l}px;
    `,
    '.webim-button-row .webim-btn span': {
      color: `${theme.tokens.colors.bg.light.primary} !important`,
    },
    '.webim-chat-block': {
      marginRight: `${theme.tokens.spacing[0]} !important`,
    },
    '.webim-control-block': css`
      position: relative !important;
      z-index: 1000 !important;
    `,
    '.webim-root.webim-desktop-mode .webim-control-block': css`
      position: absolute !important;
      bottom: -84px;
      right: 51px;
    `,
    '.webim-root.webim-mobile-mode .webim-control-block': css`
      position: absolute !important;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
    `,
    '.webim-root.webim-desktop-mode .webim-control-block .webim-action-close': {
      padding: `${theme.tokens.spacing[12]}px`,
      width: '48px !important',
      height: '48px !important',
      background: `${theme.tokens.colors.bg.light.primary} url(/icons/${theme.tokens.name}-icon-chat-close.svg) 50% 50% no-repeat`,
      borderRadius: `${theme.tokens.radius.l}px !important`,
      border: 'none !important',
      color: theme.tokens.colors.bg.light.primary,
      fontSize: '18px', // TODO - fix нет в токенах
    },
    '.webim-root.webim-desktop-mode > .webim-control-block .webim-ico.webim-ico-close':
      {
        opacity: 0,
      },
    '.webim-message-body': {
      borderRadius: `${theme.tokens.radius.l}px ${theme.tokens.radius.l}px ${theme.tokens.radius[0]}px ${theme.tokens.radius.l}px !important`,
    },
    '.webim-message-body[data-webim-custom-style="messageVisitor"]': {
      background: `${theme.tokens.colors.original.brand.primary} !important`,
    },
    '.webim-message-body[data-webim-custom-style="messageVisitor"] span': {
      color: `${theme.tokens.colors.bg.light.primary} !important`,
    },
    '.webim-message-body[data-webim-custom-style="messageVisitor"] a, .webim-file-text':
      {
        color: `${theme.tokens.colors.bg.light.primary} !important`,
      },
    '.webim-message:last-child div[data-webim-region="button-rows"]': {
      display: 'block',
    },
    '.webim-btn': {
      background: `${theme.tokens.colors.original.brand.primary} !important`,
    },
    '.webim-root .webim-send-button .webim-ico.webim-ico-send': {
      color: theme.tokens.colors.original.brand.primary,
    },
    '.webim-root .webim-offline-block .webim-description': {
      paddingTop: `${theme.tokens.spacing[20]}px`,
      background: '#f1f1ff !important', // TODO - fix нет в токенах
      color: `${theme.tokens.colors.bg.light.primary}!important`,
    },
    ':root': {
      '--react-pdf-annotation-layer': '1',
      '--annotation-unfocused-field-background':
        "url(\"data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>\")",
      '--input-focus-border-color': 'Highlight',
      '--input-focus-outline': '1px solid Canvas',
      '--input-unfocused-border-color': 'transparent',
      '--input-disabled-border-color': 'transparent',
      '--input-hover-border-color': 'black',
      '--link-outline': 'none',

      '--react-pdf-text-layer': '1',
      '--highlight-bg-color': 'rgba(180, 0, 170, 1)', // TODO - fix нет в токенах
      '--highlight-selected-bg-color': 'rgba(0, 100, 0, 1)', // TODO - fix нет в токенах
    },
    '@media screen and (forced-colors: active)': {
      ':root': {
        '--input-focus-border-color': 'CanvasText',
        '--input-unfocused-border-color': 'ActiveText',
        '--input-disabled-border-color': 'GrayText',
        '--input-hover-border-color': 'Highlight',
        '--link-outline': '1.5px solid LinkText',
        '--highlight-bg-color': 'Highlight',
        '--highlight-selected-bg-color': 'ButtonText',
      },
      '.annotationLayer .textWidgetAnnotation :is(input, textarea):required,\n  .annotationLayer .choiceWidgetAnnotation select:required,\n  .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:required':
        {
          outline: '1.5px solid selectedItem',
        },
      '.annotationLayer .linkAnnotation:hover': {
        backdropFilter: 'invert(100%)',
      },
    },
    '.annotationLayer': {
      position: 'absolute',
      top: '0',
      left: '0',
      pointerEvents: 'none',
      transformOrigin: '0 0',
      zIndex: 3,
    },
    ".annotationLayer[data-main-rotation='90'] .norotate": {
      transform: 'rotate(270deg) translateX(-100%)',
    },
    ".annotationLayer[data-main-rotation='180'] .norotate": {
      transform: 'rotate(180deg) translate(-100%, -100%)',
    },
    ".annotationLayer[data-main-rotation='270'] .norotate": {
      transform: 'rotate(90deg) translateY(-100%)',
    },
    '.annotationLayer canvas': {
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
    '.annotationLayer section': {
      position: 'absolute',
      textAlign: 'initial',
      pointerEvents: 'auto',
      boxSizing: 'border-box',
      margin: theme.tokens.spacing[0],
      transformOrigin: '0 0',
    },
    '.annotationLayer .linkAnnotation': { outline: 'var(--link-outline)' },
    '.annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton) > a':
      {
        position: 'absolute',
        fontSize: '1em', // TODO - fix нет в токенах
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
      },
    '.annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton) > a:hover':
      {
        opacity: 0.2,
        background: 'rgba(255, 255, 0, 1)', // TODO - fix нет в токенах
        boxShadow: '0 2px 10px rgba(255, 255, 0, 1)', // TODO - fix нет в токенах
      },
    '.annotationLayer .textAnnotation img': {
      position: 'absolute',
      cursor: 'pointer',
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
    },
    '.annotationLayer .textWidgetAnnotation :is(input, textarea),\n.annotationLayer .choiceWidgetAnnotation select,\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input':
      {
        backgroundImage: 'var(--annotation-unfocused-field-background)',
        border: `${theme.tokens.border.m}px solid var(--input-unfocused-border-color)`,
        boxSizing: 'border-box',
        font: 'calc(9px * var(--scale-factor)) sans-serif',
        height: '100%',
        margin: theme.tokens.spacing[0],
        verticalAlign: 'top',
        width: '100%',
      },
    '.annotationLayer .textWidgetAnnotation :is(input, textarea):required,\n.annotationLayer .choiceWidgetAnnotation select:required,\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:required':
      {
        outline: '1.5px solid red',
      },
    '.annotationLayer .choiceWidgetAnnotation select option': {
      padding: theme.tokens.spacing[0],
    },
    '.annotationLayer .buttonWidgetAnnotation.radioButton input': {
      borderRadius: theme.tokens.radius.round,
    },
    '.annotationLayer .textWidgetAnnotation textarea': { resize: 'none' },
    '.annotationLayer .textWidgetAnnotation :is(input, textarea)[disabled],\n.annotationLayer .choiceWidgetAnnotation select[disabled],\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input[disabled]':
      {
        background: 'none',
        border: `${theme.tokens.border.m}px solid var(--input-disabled-border-color)`,
        cursor: 'not-allowed',
      },
    '.annotationLayer .textWidgetAnnotation :is(input, textarea):hover,\n.annotationLayer .choiceWidgetAnnotation select:hover,\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:hover':
      {
        border: `${theme.tokens.border.m}px solid var(--input-hover-border-color)`,
      },
    '.annotationLayer .textWidgetAnnotation :is(input, textarea):hover,\n.annotationLayer .choiceWidgetAnnotation select:hover,\n.annotationLayer .buttonWidgetAnnotation.checkBox input:hover':
      {
        borderRadius: '2px', // TODO - fix нет в токенах
      },
    '.annotationLayer .textWidgetAnnotation :is(input, textarea):focus,\n.annotationLayer .choiceWidgetAnnotation select:focus':
      {
        background: 'none',
        border: `${theme.tokens.border.m}px solid var(--input-focus-border-color)`,
        borderRadius: '2px', // TODO - fix нет в токенах
        outline: 'var(--input-focus-outline)',
      },
    '.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) :focus':
      {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
      },
    '.annotationLayer .buttonWidgetAnnotation.checkBox :focus': {
      border: `${theme.tokens.border.m}px solid var(--input-focus-border-color)`,
      borderRadius: '2px', // TODO - fix нет в токенах
      outline: 'var(--input-focus-outline)',
    },
    '.annotationLayer .buttonWidgetAnnotation.radioButton :focus': {
      border: `${theme.tokens.border.m}px solid var(--input-focus-border-color)`,
      outline: 'var(--input-focus-outline)',
    },
    '.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after,\n.annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before':
      {
        backgroundColor: 'CanvasText',
        content: "''",
        display: 'block',
        position: 'absolute',
      },
    '.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after':
      {
        height: '80%',
        left: '45%',
        width: '1px',
      },

    '.editor-paragraph': {
      color: theme.tokens.colors.text.light.primary,
      fontSize: theme.tokens.typography.variant.body2.fontSize,
      lineHeight: theme.tokens.typography.variant.body2.lineHeight,
      fontWeight: theme.tokens.typography.variant.body2.fontWeight,
      maxWidth: '100%',
      letterSpacing: '0em',
      margin: 0,
    },

    '.editor-heading-h5': {
      color: theme.tokens.colors.text.light.primary,
      fontSize: theme.tokens.typography.variant.h5.fontSize,
      lineHeight: theme.tokens.typography.variant.h5.lineHeight,
      fontWeight: theme.tokens.typography.variant.h5.fontWeight,
      letterSpacing: '0em',
      margin: 0,
    },

    '.editor-heading-h6': {
      color: theme.tokens.colors.text.light.primary,
      fontSize: theme.tokens.typography.variant.h6.fontSize,
      lineHeight: theme.tokens.typography.variant.h6.lineHeight,
      fontWeight: theme.tokens.typography.variant.h6.fontWeight,
      letterSpacing: '0em',
      margin: 0,
    },

    '.italic-text': {
      fontStyle: 'italic',
    },

    '.underline-text': {
      textDecoration: 'underline',
    },

    '.strikethrough-text': {
      textDecoration: 'line-through',
    },

    '.code-text': {
      backgroundColor: theme.tokens.colors.bg.greyscale.tertirary,
      letterSpacing: '2px',
      fontFamily: 'PT Mono, Consolas, Menlo, monospace',
    },

    '.editor-list-ul .editor-listItem': {
      listStyleType: 'disc',

      '&.editor-nestedListItem': {
        listStyleType: 'none',
      },
    },

    '.editor-list-ol .editor-listItem': {
      listStyleType: 'decimal',

      '&.editor-nestedListItem': {
        listStyleType: 'none',
      },
    },

    '.editor-listItem': {
      marginLeft: theme.px(theme.tokens.spacing[20]),
      color: theme.tokens.colors.text.light.primary,
      fontSize: theme.tokens.typography.variant.body2.fontSize,
      lineHeight: theme.tokens.typography.variant.body2.lineHeight,
      fontWeight: theme.tokens.typography.variant.body2.fontWeight,
      backgroundColor: 'transparent !important',
    },

    '.editor-link': {
      color: theme.tokens.colors.original.brand.primary,
      textDecoration: 'none',
    },

    '.editor-table': {
      borderCollapse: 'collapse',
      width: '100%',
      boxShadow: `0 0 0 1px ${theme.tokens.colors.stroke.primary}`,
      overflow: 'hidden',
      border: '1px solid',
      borderColor: theme.tokens.colors.stroke.primary,
      borderRadius: theme.tokens.radius.m,
      borderSpacing: 0,
      tableLayout: 'fixed',
    },

    '.editor-tableCell': {
      border: '1px solid',
      borderColor: theme.tokens.colors.stroke.primary,
      padding: `${theme.px(theme.tokens.spacing[16])}px ${theme.px(
        theme.tokens.spacing[12],
      )}px`,
      textAlign: 'left',
      verticalAlign: 'top',
    },

    '.editor-reference': {
      border: '1px solid',
      borderLeft: '8px solid',
      borderColor: theme.tokens.colors.accent.stroke.warning,
      borderRadius: theme.tokens.radius.s,
      padding: `${theme.px(theme.tokens.spacing[8])}px ${theme.px(
        theme.tokens.spacing[12],
      )}px`,
      position: 'relative',
    },

    '.editor-reference-placeholder': {
      position: 'absolute',
      top: '8px',
      left: '12px',
      pointerEvents: 'none',
      color: theme.tokens.colors.text.light.tertirary,
      letterSpacing: '0em',
    },

    '.editor-code-block': {
      border: '1px solid',
      borderColor: theme.tokens.colors.stroke.primary,
      borderRadius: theme.tokens.radius.l,
      padding: `${theme.px(theme.tokens.spacing[16])}px`,
      position: 'relative',
      backgroundColor: theme.tokens.colors.bg.greyscale.secondary,
      fontFamily: 'PT Mono, Consolas, Menlo, monospace',
    },

    '.editor-code-block-placeholder': {
      position: 'absolute',
      top: '16px',
      left: '16px',
      pointerEvents: 'none',
      color: theme.tokens.colors.text.light.tertirary,
      fontFamily: 'Inter, Arial',
    },

    '.editor-quote-node': {
      border: '1px solid',
      borderLeft: '8px solid',
      borderColor: theme.tokens.colors.original.brand.quaternary,
      borderRadius: theme.tokens.radius.s,
      backgroundColor: theme.tokens.colors.bg.greyscale.primary,
      padding: `${theme.px(theme.tokens.spacing[16])}px`,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: `${theme.px(theme.tokens.spacing[8])}px`,
    },

    '.editor-quote-node br': {
      display: 'none',
    },

    '.editor-quote-text': {
      fontStyle: 'italic',
    },

    '.editor-author-name': {
      fontSize: theme.tokens.typography.variant.subtitle1.fontSize,
      lineHeight: theme.tokens.typography.variant.subtitle1.lineHeight,
      fontWeight: theme.tokens.typography.variant.subtitle1.fontWeight,
    },

    blockquote: {
      margin: 0,
      padding: 0,
    },

    '.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before': {
      transform: 'rotate(45deg)',
    },

    '.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after': {
      transform: 'rotate(-45deg)',
    },
    '.annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before':
      {
        borderRadius: theme.tokens.radius.round,
        height: '50%',
        left: '30%',
        top: '20%',
        width: '50%',
      },
    '.annotationLayer .textWidgetAnnotation input.comb': {
      fontFamily: 'monospace',
      paddingLeft: `${theme.tokens.spacing[2]}px`,
      paddingRight: theme.tokens.spacing[0],
    },
    '.annotationLayer .textWidgetAnnotation input.comb:focus': {
      width: '103%',
    },
    '.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input':
      {
        appearance: 'none',
      },
    '.annotationLayer .popupTriggerArea': { height: '100%', width: '100%' },
    '.annotationLayer .fileAttachmentAnnotation .popupTriggerArea': {
      position: 'absolute',
    },
    '.annotationLayer .popupWrapper': {
      position: 'absolute',
      fontSize: 'calc(9px * var(--scale-factor))',
      width: '100%',
      minWidth: 'calc(180px * var(--scale-factor))',
      pointerEvents: 'none',
    },
    '.annotationLayer .popup': {
      position: 'absolute',
      maxWidth: 'calc(180px * var(--scale-factor))',
      backgroundColor: 'rgba(255, 255, 153, 1)', // TODO - fix нет в токенах
      boxShadow:
        '0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor))\n    rgba(136, 136, 136, 1)', // TODO - fix нет в токенах
      borderRadius: 'calc(2px * var(--scale-factor))',
      padding: 'calc(6px * var(--scale-factor))',
      marginLeft: 'calc(5px * var(--scale-factor))',
      cursor: 'pointer',
      font: 'message-box',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      pointerEvents: 'auto',
    },
    '.annotationLayer .popup > *': {
      fontSize: 'calc(9px * var(--scale-factor))',
    },
    '.annotationLayer .popup h1': { display: 'inline-block' },
    '.annotationLayer .popupDate': {
      display: 'inline-block',
      marginLeft: 'calc(5px * var(--scale-factor))',
    },
    '.annotationLayer .popupContent': {
      borderTop: `${theme.tokens.border.s}px solid rgba(51, 51, 51, 1)`, // TODO - fix нет в токенах
      marginTop: 'calc(2px * var(--scale-factor))',
      paddingTop: 'calc(2px * var(--scale-factor))',
    },
    '.annotationLayer .richText > *': {
      whiteSpace: 'pre-wrap',
      fontSize: 'calc(9px * var(--scale-factor))',
    },
    '.annotationLayer .highlightAnnotation,\n.annotationLayer .underlineAnnotation,\n.annotationLayer .squigglyAnnotation,\n.annotationLayer .strikeoutAnnotation,\n.annotationLayer .freeTextAnnotation,\n.annotationLayer .lineAnnotation svg line,\n.annotationLayer .squareAnnotation svg rect,\n.annotationLayer .circleAnnotation svg ellipse,\n.annotationLayer .polylineAnnotation svg polyline,\n.annotationLayer .polygonAnnotation svg polygon,\n.annotationLayer .caretAnnotation,\n.annotationLayer .inkAnnotation svg polyline,\n.annotationLayer .stampAnnotation,\n.annotationLayer .fileAttachmentAnnotation':
      {
        cursor: 'pointer',
      },
    '.annotationLayer section svg': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
    },
    '.annotationLayer .annotationTextContent': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: 0,
      color: 'transparent',
      userSelect: 'none',
      pointerEvents: 'none',
    },
    '.annotationLayer .annotationTextContent span': {
      width: '100%',
      display: 'inline-block',
    },
    "[data-main-rotation='90']": {
      transform: 'rotate(90deg) translateY(-100%)',
    },
    "[data-main-rotation='180']": {
      transform: 'rotate(180deg) translate(-100%, -100%)',
    },
    "[data-main-rotation='270']": {
      transform: 'rotate(270deg) translateX(-100%)',
    },
    '.textLayer': {
      position: 'absolute',
      textAlign: 'initial',
      inset: '0',
      overflow: 'hidden',
      lineHeight: 1,
      textSizeAdjust: 'none',
      forcedColorAdjust: 'none',
      transformOrigin: '0 0',
      zIndex: 2,
    },
    '.textLayer :is(span, br)': {
      color: 'transparent',
      position: 'absolute',
      whiteSpace: 'pre',
      cursor: 'text',
      margin: theme.tokens.spacing[0],
      transformOrigin: '0 0',
    },
    '.textLayer span.markedContent': { top: '0', height: '0' },
    '.textLayer .highlight': {
      margin: '-1px', // TODO - fix нет в токенах
      padding: '1px', // TODO - fix нет в токенах
      backgroundColor: 'var(--highlight-bg-color)',
      borderRadius: `${theme.tokens.radius.xs}px`,
    },
    '.textLayer .highlight.appended': { position: 'initial' },
    '.textLayer .highlight.begin': {
      borderRadius: `${theme.tokens.radius.xs}px ${theme.tokens.radius[0]} ${theme.tokens.radius[0]} ${theme.tokens.radius.xs}px`,
    },
    '.textLayer .highlight.end': {
      borderRadius: `${theme.tokens.radius[0]} ${theme.tokens.radius.xs}px ${theme.tokens.radius.xs}px ${theme.tokens.radius[0]}`,
    },
    '.textLayer .highlight.middle': {
      borderRadius: theme.tokens.radius[0],
    },
    '.textLayer .highlight.selected': {
      backgroundColor: 'var(--highlight-selected-bg-color)',
    },
    '.textLayer br::selection': { background: 'transparent' },
    '.textLayer .endOfContent': {
      display: 'block',
      position: 'absolute',
      inset: '100% 0 0',
      zIndex: -1,
      cursor: 'default',
      userSelect: 'none',
    },
    '.textLayer .endOfContent.active': { top: '0' },
    '.mailtoLink': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
  };
};

export const GlobalStyles = () => {
  useEffect(() => {
    const isWindows = navigator.userAgent.indexOf('Win') != -1;
    const isLinux = navigator.userAgent.indexOf('Linux') != -1;

    const isWinOrLin = isWindows || isLinux;

    if (isWinOrLin) {
      document.body.classList.add('mac-scroll-styles');
    }
  }, []);

  const styles = useStyles();

  return <Global styles={styles} />;
};
